<template>
  <div>
    <div class="flex w-full">
      <div
        class="
          w-full
          bg-white
          dark:bg-slate-800
          border border-gray-200
          dark:border-slate-600
          sm:px-5
          py-4
          sm:m-4
          max-w-4xl
          md:mx-auto
        "
      >
        <slot name="content"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>